"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const search = (sdk) => {
    const { sdkConfig: { url }, } = sdk;
    const httpClient = sdk.httpClient;
    return {
        unifiedSearch: async (searchParams, abortSignal) => {
            const endpoint = `${url}/v4/search/unified`;
            const result = await httpClient.get(endpoint, { query: searchParams, abortSignal });
            return result;
        },
        relatedTopics: async (params, abortSignal) => {
            const endpoint = `${url}/v4/search/related-topics`;
            const result = await httpClient.get(endpoint, { query: params, abortSignal });
            return result.data;
        },
    };
};
exports.default = search;
